module.exports = __webpack_public_path__ + "img/1506388638.6247b6ba.jpg";